import styled from 'styled-components/macro';

export const MerchantRegistrationFormDiv = styled.div`
  text-align: left;
  @media screen and (min-width: 768px) {
    display: flex;
    margin-top: 50px;
  }
  @media screen and (min-width: 768px) and (max-width: 1023px) {
    padding-right: 1rem;
  }
`;

export const MerchantRegistrationHeaderDiv = styled.div`
  @media screen and (max-width: 767px) {
    text-align: center;
  }
  p {
    margin-bottom: 15px;
  }
  h5 {
    margin-bottom: 15px;
    line-height: 1.7rem;
    letter-spacing: 0.03em;
  }
`;
